import { ConfigurationSettings } from './client-configuration-grid';

export class ConfigurationsUpdate {
  workItemActionType: WorkItemActionType;
  clientConfigurations: ClientUpdateConfiguration[];
  comment: string;
}

export enum WorkItemActionType {
  Keep = 'Keep',
  Update = 'Update',
  Remove = 'Remove'
}

export class ClientUpdateConfiguration {
  clientId: number;
  configuration: ConfigurationSettings[];
}
